
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useOrganization } from '@/contexts/OrganizationContext';

export interface CampaignOption {
  id: string;
  name: string;
}

export function useCampaignFilter() {
  const { currentOrganization } = useOrganization();

  return useQuery({
    queryKey: ['campaigns-filter', currentOrganization?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('campaigns')
        .select('id, name')
        .order('start_date', { ascending: false });
      
      if (error) throw error;
      
      return data as CampaignOption[];
    },
    enabled: !!currentOrganization?.id,
  });
}
